(function(){
    'use strict';
    
    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('offers', {
                parent: 'app',
                url: '/offers?page&size&originId',
                params: {
                    page: "0",
                    size: "10",
                    originId: null
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/offers/offers.html',
                        controller: 'offersCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['offers']);
                    }],
                    offers: ['offerService','$stateParams', function(offerService, $stateParams){
                        return offerService.getOffers($stateParams.page, $stateParams.size, true, $stateParams.originId);
                    }]
                }
            })
            .state('offerDelete', {
                parent: 'offers',
                url: '/offer/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/offers/deleteOffer.html',
                        controller: 'deleteOfferCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'offer': ['offerService', function(offerService) {
                                return offerService.getOffer($stateParams.id, true);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('offers', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('offerNew', {
                parent: 'app',
                url: '/offer/new?originId',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/offers/newOffer.html',
                        controller: 'newOfferCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['offers']);
                    }],
                    cities: ['locationService', function(locationService){
                        return locationService.getLocations(true, true);
                    }]
                }
            })
            .state('offerEdit', {
                parent: 'app',
                url: '/offer/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/offers/editOffer.html',
                        controller: 'editOfferCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['offers']);
                    }],
                    offer: ['offerService', '$stateParams', function(offerService, $stateParams){
                        return offerService.getOffer($stateParams.id, true);
                    }],
                    cities: ['locationService', function(locationService){
                        return locationService.getLocations(true, true);
                    }]
                }
            });
    }
})();